import { ActionIcon, Flex, getTheme, Text } from '@conexasaude/conexa-hero'
import { FunctionComponent, memo } from 'react'
import { InboxHeaderProps } from './InboxHeader.types'
import { autoCapitalize } from '@conexasaude/front-utils/formatters'

export const InboxHeader: FunctionComponent<InboxHeaderProps> = memo(
  ({ professionalName, goBack }) => {
    const theme = getTheme()

    return (
      <Flex align="center" gap={theme.spacing.xxs}>
        <ActionIcon
          icon="arrow-left"
          mode="plain"
          size="small"
          iconColor={theme.colors.neutral[200]}
          onClick={goBack}
        />
        <Text variant="headingSmall" ellipsis>
          {autoCapitalize(professionalName || '')}
        </Text>
      </Flex>
    )
  },
)

InboxHeader.displayName = 'InboxHeader'
